import { render, staticRenderFns } from "./graphicBsquatMasculine.vue?vue&type=template&id=2448578a&"
import script from "./graphicBsquatMasculine.js?vue&type=script&lang=js&"
export * from "./graphicBsquatMasculine.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports